<ng-container>
  <nb-card class="add-documents">
    <nb-card-header i18n="@@AdditionalDocuments" style="border: none">Документы
      <button i18n-nbTooltip="@@Upload" (click)="showUploadForm = !showUploadForm" nbTooltip="Загрузить" nbButton status="control" size="small">
        <nb-icon icon="{{showUploadForm ? 'minus-outline' : 'plus-outline'}}"></nb-icon>
      </button>
    </nb-card-header>
    <nb-card-body>
      <label i18n="@ClickOrDragDocument" for="document-uploader-input" *ngIf="showUploadForm"
             class="well my-drop-zone"
             ng2FileDrop
             [ngClass]="{'file-over': hasDropZoneOver}"
             (fileOver)="fileOver($event)"
             (onFileDrop)="upload()"
             [uploader]="uploader">Кликните или перетащите сюда документ</label>
      <input type="file" ng2FileSelect (change)="upload()" [uploader]="uploader" multiple id="document-uploader-input" style="display:none"/>

      <nb-list *ngIf="model?.documents?.length">
        <nb-list-item cdkDropList (cdkDropListDropped)="drop($event)">
          <div *ngFor="let document of model.documents" cdkDrag>
            <a [href]="documentUri(document.fileName)">{{ document.header }}</a>
            <div class="float-end">
              <button type="button" size="small" status="control">
                <nb-icon i18n-nbTooltip="@@Delete" (click)="removeDialog(document)" nbTooltip="Удалить" icon="close-outline"/>
              </button>
            </div>
          </div>
        </nb-list-item>
      </nb-list>
    </nb-card-body>
  </nb-card>
</ng-container>
